/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ShopifyFreightSettings } from "./ShopifyFreightSettings";
import {
  ShopifyFreightSettingsFromJSON,
  ShopifyFreightSettingsFromJSONTyped,
  ShopifyFreightSettingsToJSON,
  ShopifyFreightSettingsToJSONTyped,
} from "./ShopifyFreightSettings";

/**
 *
 * @export
 * @interface UpdateShopifySettingsRequest
 */
export interface UpdateShopifySettingsRequest {
  /**
   *
   * @type {string}
   * @memberof UpdateShopifySettingsRequest
   */
  integrationId: string;
  /**
   *
   * @type {ShopifyFreightSettings}
   * @memberof UpdateShopifySettingsRequest
   */
  settings: ShopifyFreightSettings;
}

/**
 * Check if a given object implements the UpdateShopifySettingsRequest interface.
 */
export function instanceOfUpdateShopifySettingsRequest(
  value: object,
): value is UpdateShopifySettingsRequest {
  if (!("integrationId" in value) || value["integrationId"] === undefined)
    return false;
  if (!("settings" in value) || value["settings"] === undefined) return false;
  return true;
}

export function UpdateShopifySettingsRequestFromJSON(
  json: any,
): UpdateShopifySettingsRequest {
  return UpdateShopifySettingsRequestFromJSONTyped(json, false);
}

export function UpdateShopifySettingsRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UpdateShopifySettingsRequest {
  if (json == null) {
    return json;
  }
  return {
    integrationId: json["integrationId"],
    settings: ShopifyFreightSettingsFromJSON(json["settings"]),
  };
}

export function UpdateShopifySettingsRequestToJSON(
  json: any,
): UpdateShopifySettingsRequest {
  return UpdateShopifySettingsRequestToJSONTyped(json, false);
}

export function UpdateShopifySettingsRequestToJSONTyped(
  value?: UpdateShopifySettingsRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    integrationId: value["integrationId"],
    settings: ShopifyFreightSettingsToJSON(value["settings"]),
  };
}
